import NiceModal, { useModal } from "@ebay/nice-modal-react";

export interface NiceModalInjection<Return = undefined> {
  props: {
    isOpen: boolean;
    onOpenChange: (visible: boolean) => void;
    onClose: () => void;
  };
  resolve: Return extends undefined ? () => void : (r: Return) => void;
  reject: (e?: Error) => void;
}

export const createNiceModal = <Props extends Record<string, unknown>, Return>(
  Comp: React.ComponentType<Props & { _modal: NiceModalInjection<Return> }>,
) => {
  const CompWrapper: React.FC<Props> = (props) => {
    const modal = useModal();
    const _modal: NiceModalInjection<Return> = {
      props: {
        isOpen: modal.visible,
        onOpenChange: (isOpen: boolean) => {
          if (!isOpen) {
            modal.reject();
            void modal.hide();
          }
        },
        onClose: () => {
          modal.reject();
          void modal.hide();
        },
      },
      resolve: ((r: Return) => {
        modal.resolve(r);
        void modal.hide();
      }) as any,
      reject: (e?: Error) => {
        modal.reject(e);
        void modal.hide();
      },
    };
    return <Comp {...props} _modal={_modal} />;
  };
  const Modal = NiceModal.create(CompWrapper);
  return async (props: Props): Promise<Return> =>
    await NiceModal.show(Modal, props as any);
};
